/**
 * TrailmasterCrown — the 👑 marker rendered on personas who currently
 * hold the Trailmaster role for the session (session_council_metadata.
 * core_persona_id).
 *
 * Three variants for different mount surfaces (SP3 I.3-I.4):
 *   - corner-overlay : absolute-positioned 👑 in the top-right of a
 *                       PersonaAvatar (conditional wrap per SP3-SC-03)
 *   - inline-prefix  : ' 👑 ' before a persona name (CrewStrip PersonaDot)
 *   - suffix         : ' 👑' after a persona name (PhaseTrailBlock)
 */
import React from 'react';


type Variant = 'corner-overlay' | 'inline-prefix' | 'suffix';
type Size = 'small' | 'medium' | 'large';


interface TrailmasterCrownProps {
  size?: Size;
  variant?: Variant;
}


const SIZE_PX: Record<Size, number> = {
  small: 12,
  medium: 16,
  large: 20,
};


export const TrailmasterCrown: React.FC<TrailmasterCrownProps> = ({
  size = 'small',
  variant = 'corner-overlay',
}) => {
  if (variant === 'inline-prefix') {
    return (
      <span
        title="Trailmaster"
        aria-label="Trailmaster"
        className="mr-0.5"
      >
        👑
      </span>
    );
  }
  if (variant === 'suffix') {
    return (
      <span
        title="Trailmaster"
        aria-label="Trailmaster"
        className="ml-1"
      >
        👑
      </span>
    );
  }
  // corner-overlay (default)
  const px = SIZE_PX[size];
  return (
    <span
      title="Trailmaster"
      aria-label="Trailmaster"
      style={{
        position: 'absolute',
        top: 0,
        right: 0,
        width: px,
        height: px,
        fontSize: px - 2,
        lineHeight: `${px}px`,
        textAlign: 'center',
        pointerEvents: 'none',
      }}
    >
      👑
    </span>
  );
};
